import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './pages/home/Home';
import ActiveEmail from './pages/ActiveEmail';
import { useDispatch } from 'react-redux';
import { loadUser } from './store/reducer/userSlice'
import SocialLoginSuccess from './pages/SocialLoginSuccess';
import Admin from './pages/admin';
import ProtectedRoute from './components/routing/ProtectedRoute';
import DetailNews from './pages/detailNews';
import Category from './pages/category';
import Search from './pages/search';
import Me from './pages/me';

function App() {
  const dispatch = useDispatch()

  useEffect(() => {
    (async () => await dispatch(loadUser()))()
  },[dispatch])

  return (
    <Router>
      <Switch>
        <Route  path="/login-success" exact component={SocialLoginSuccess} />
        <Route  path="/active-email" exact component={ActiveEmail} />
        <ProtectedRoute path="/admin"  component={Admin} />
        <Route path="/me" component={Me} />
        <Route  path="/category/news" exact component={Category} />
        <Route  path="/news/:id" exact component={DetailNews} />
        <Route  path="/search" exact component={Search} />
        <Route  path="/" exact component={Home} />
      </Switch>
    </Router>
  );
}

export default App;
